import { from } from 'rxjs';

//#region Shared Component Exports
export * from './shared/header/header.component';
export * from './shared/footer/footer.component';
export * from './shared/skeleton/skeleton.component';
export * from './shared/progressbar/progressbar.component';
export * from './shared/menu/menu.component'
export * from './shared/menu/equipment-menu.component'
export * from './shared/menu//setting-menu/setting-menu.component'
//export * from './shared/menu//manageoem-menu/manageoem-menu.component'
export * from './shared/bottomSearch/bottom-search.component'
//#endregion

//#region equipment Component Exports
export * from './Equipment/SearchEquipment/searchequipment.component'
export * from './Equipment/equipment-main.component'
export * from './Equipment/addequiment/addequiment.component';
export * from './Equipment/manageoem/manageoem.component';
//export * from './Equipment/manageoem/manage-oem-list.component';
export * from './Equipment/masstransfer/mass-transfer.component';
export * from './Equipment/massupdate/mass-update.component';
export * from './Equipment/namemanager/name-manager.component';
export * from './Equipment/SearchEquipment/searchequipment.component';
export * from './Equipment/equipment-main.component'; 
//export * from './Equipment/manage-oem/manage-oem.component';
export * from './Equipment/namemanager/name-manager.component'
//#endregion

//#region Alerts Component Exports

export * from './alerts/alert-main/alert-main.component';

//#endregion

//#region Dashboard Component Exports

export * from './dashboard/dashboard.component';

//#endregion

//#region ServiceRequest Component Exports
export * from './serviceRequest/serv-req-main/serv-req-main.component';

//#endregion

//#region Tickets Component Exports
export * from './tickets/ticket-main/ticket-main.component';
export * from './tickets/ticketInfo/ticket-info.component';
export * from './tickets/ticket-summary/ticket-summary.component';
export * from './tickets/partsUsed/parts-used.component';
export * from './tickets/testEquipmentUsed/test-equipment-used.component'
export * from './tickets/batchTicketInfo/batch-ticket-info.component'
export * from './tickets/batch-ticket-summary/batch-ticket-summary.component'
//Batch Template 
export * from './tickets/batchTicketInfo/batchTemplates/covid-attestation/covid-attestation.component'
export * from './tickets/batchTicketInfo/batchTemplates/electrical-safety/electrical-safety.component'
export * from './tickets/batchTicketInfo/batchTemplates/network-survey/network-survey.component'
export * from './tickets/batchTicketInfo/batchTemplates/software-update/software-update.component'
export * from './tickets/batchTicketInfo/batchTemplates/water-duration/water-duration.component'
export * from './tickets/batchTicketInfo/batchTemplates/water-frequency/water-frequency.component'
export * from './tickets/batchTicketInfo/batchTemplates/water-volume/water-volume.component'
export * from './tickets/batchTicketInfo/batchTemplates/water-volume-monthly/water-volume-monthly.component'
export * from './tickets/batchTicketInfo/batchTemplates/water-volume-temp/water-volume-temp.component'
export * from './tickets/batchTicketInfo/batchTemplates/mod-sqa/mod-sqa.component'
//#endregion

//#region User Component Exports
export * from './user/user-info/user-info.component';

//#endregion

//#region Parts Component Exports
export * from './parts/part-summary/part-summary.component';

//#endregion
//#region administrator Component Exports
export * from './administrator/admin-main.component';

//#endregion
//#region reinitialize Component Exports
export * from './reintialize/reintialize-main.component';

//#endregion
//#region report Component Exports
export * from './reports/report-main.component';
export * from './reports/run-report/run-report.component';
export * from './reports/lab-report/lab-report.component';


//#endregion
//#region setting Component Exports
export * from './settings/setting-bart-vision/setting-bart-vision.component';
export * from './settings/setting-facility-format/setting-facility-format.component';
export * from './settings/setting-favorite-parts/setting-favorite-parts.component';
export * from './settings/setting-favorite-test-equipment/setting-favorite-test-equipment.component';
export * from './settings/settings-main.component';

//#endregion


//#endregion
//#region SystemX Component Exports
export * from './systemX/systemx-main.component';

//#endregion
export * from './home/home.component';

//
export * from './shared/combos/cmdmodel.component';
export * from './shared/combos/cmdmanufacturer.component';
export * from './shared/combos/cmdequipment.component';
export * from './Equipment/masstransfer/mass-transfer.component';
export * from './Equipment/massupdate/mass-update.component';

//#region boottomStandard Component Exports
export * from './bottomStandard/ticketSearch/ticket-search.component';
export * from './bottomStandard/partsSearch/parts-search.component';
export * from './bottomStandard/resourcesSearch/resources-search.component';
//#endregion

//#region batch Manager Component Exports
export * from './administrator/batch-manager/batch-manager.component';

export * from  '../components/shared/part-manger-menu/part-manger-menu.component'

//#endregion


export * from './administrator/sqaCodeManager/sqa-code-manager.component';
export * from './administrator/serial-number-merge/serial-number-merge.component'
//#endregion

export * from './auth-call-back/auth-call-back.component'
export * from './error/error.component'
export * from './error/pageNotFound/page-not-found.component';

//#region --Water Lab
export * from './waterLab/water-lab-main.component';
export * from './waterLab/request/create-lab-request/create-lab-request.component';
export * from './waterLab/request/lab-requests/lab-requests.component';
export * from './shared/menu/labs-menu/labs-menu.component';
export * from './shared/loader/loader.component';
export * from './waterLab/request/lab-request-history/lab-request-history.component';
export * from './waterLab/request/preview-label/preview-label.component';
export * from './waterLab/shipping-manifest/shipping-manifest.component';
export * from './waterLab/lab-results/lab-results.component';
export * from './waterLab/print-label-summary/print-label-summary.component'
export * from './waterLab/shipping-manifest/pending-manifest/pending-manifest.component';
export * from './administrator/water-lab/lab-manager.component'
export * from './administrator/water-lab/active-inactive-labs/active-inactive-labs.component'
export * from './administrator/water-lab/lab-by-model/lab-by-model.component'
export * from './administrator/water-lab/lab-frequency-alert/lab-frequency-alert.component'
export * from './administrator/water-lab/lab-range-alert/lab-range-alert.component'
export * from './administrator/water-lab/lab-range-alert/lab-range-assign/lab-range-assign.component'
export * from './waterLab/shipping-manifest/pending-manifest/enter-draw-date/enter-draw-date.component';
export * from './waterLab/shipping-manifest/pending-manifest/cancel/cancel.component';
export * from './waterLab/shipping-manifest/historical-manifest/historical-manifest.component';
export * from './waterLab/shipping-manifest/print-manifest/print-manifest.component';
export * from './waterLab/shipping-manifest/additional-test/additional-test.component';
export * from './waterLab/lab-results/lab-result-history/lab-result-history.component';
export * from './waterLab/lab-results/print-lab-result/print-lab-result.component';
export * from './waterLab/shared/view-lab-results/view-lab-results.component';
export * from './waterLab/lab-results/lab-result-history/lab-result-history.component';
export * from './administrator/water-lab/lab-by-model/add-test-to-model/add-test-to-model.component';
export * from './waterLab/shared/request-history/request-history.component';

export * from './waterLab/lab-action-item/lab-action-item.component'
export * from './waterLab/lab-action-item/missing-draw-date/missing-draw-date.component'
export * from './waterLab/lab-action-item/no-lab-request/no-lab-request.component'
export * from './waterLab/lab-action-item/overdue-labs/overdue-labs.component'
export * from './waterLab/lab-action-item/redraw-labs/redraw-labs.component'
export * from './waterLab/lab-action-item/unmapped-lab-test/unmapped-lab-test.component'
export * from './waterLab/lab-action-item/upcomming-labs/upcomming-labs.component'
export * from './waterLab/shared/view-lab-alert/view-lab-alert.component'
//#endregion